import { useMutation } from "@tanstack/react-query";
import {
  ISD_CODE,
  LOGIN_ENDPOINT,
  LOGIN_PRODUCT_ID,
  LOGIN_TENANT_ID,
  PLATFORM,
  REQUEST_PRODUCT_ID,
  VALID_ROLE_IDS,
} from "constants/config";

const loginWithOtp = async (payload) => {
  const response = await fetch(LOGIN_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      platform: PLATFORM,
      "product-id": Number(LOGIN_PRODUCT_ID),
      "tenant-id": Number(LOGIN_TENANT_ID),
    },
    body: JSON.stringify({
      isd_code: ISD_CODE,
      phone: payload.phone,
      otp: payload.otp,
      product_id: REQUEST_PRODUCT_ID,
      tenant_id: LOGIN_TENANT_ID,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    const message = data?.message || "Something went wrong please try again.";
    throw new Error(message);
  }

  const receivedData = data && data.data;

  const hasValidRole = receivedData.roles.some((roleId) =>
    VALID_ROLE_IDS.includes(roleId)
  );

  if (!hasValidRole) {
    throw new Error(
      "You do not have the required permissions to access this platform."
    );
  }

  return receivedData;
};

export const useLoginWithOtp = () => useMutation({ mutationFn: loginWithOtp });
